import type { Assignment } from '@/types/domain';
import type { Stop } from '@/lib/grouping';

/**
 * Company + address + city for log type strings (Martin #41). No suite.
 * Example: "ACME INC 123 Main St Toronto"
 */
export function formatLogLocation(parts: {
  name?: string | null;
  address?: string | null;
  city?: string | null;
}): string {
  return [parts.name, parts.address, parts.city]
    .map((p) => p?.trim())
    .filter((p): p is string => !!p && p.length > 0)
    .join(' ');
}

export function stopLogLocation(stop: Pick<Stop, 'name' | 'address' | 'city'>): string {
  return formatLogLocation(stop);
}

export function assignmentLogLocation(
  a: Assignment,
  kind: 'pickup' | 'delivery',
): string {
  return kind === 'pickup'
    ? formatLogLocation({
        name: a.remShipperName,
        address: a.remShipperAddress,
        city: a.remShipperCity,
      })
    : formatLogLocation({
        name: a.remConsigneeName,
        address: a.remConsigneeAddress,
        city: a.remConsigneeCity,
      });
}
